import { useApp } from "../context/AppContext";

const statusStyles = {
  open: "bg-sky-100 text-sky-700",
  in_progress: "bg-yellow-100 text-yellow-700",
  completed: "bg-emerald-100 text-emerald-700",
  paid: "bg-slate-900 text-white",
  pending: "bg-orange-100 text-orange-700",
  income: "bg-emerald-100 text-emerald-700",
  expense: "bg-red-100 text-red-700",
};

export const StatusBadge = ({ status }) => {
  const { t } = useApp();
  const label = status === "paid" ? t("paid_status") : t(status);
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide ${statusStyles[status] || "bg-slate-100 text-slate-700"}`}
    >
      {label}
    </span>
  );
};

export const PageHeader = ({ title, children }) => (
  <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
    <h1 className="font-heading text-3xl sm:text-4xl tracking-tight font-bold text-slate-900">{title}</h1>
    <div className="flex gap-2">{children}</div>
  </div>
);

export const EmptyRow = ({ colSpan }) => {
  const { t } = useApp();
  return (
    <tr>
      <td colSpan={colSpan} className="text-center py-10 text-slate-400 text-sm">
        {t("noData")}
      </td>
    </tr>
  );
};

export const TableShell = ({ headers, children }) => (
  <div className="bg-white border border-slate-200 rounded-lg overflow-x-auto shadow-sm">
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b border-slate-200 bg-slate-50">
          {headers.map((h, i) => (
            <th key={i} className="text-left px-4 py-3 font-semibold text-slate-600 text-xs uppercase tracking-wider whitespace-nowrap">
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-100">{children}</tbody>
    </table>
  </div>
);
